import { render, staticRenderFns } from "./taskForm.vue?vue&type=template&id=71bc20d0&"
import script from "./taskForm.vue?vue&type=script&lang=js&"
export * from "./taskForm.vue?vue&type=script&lang=js&"
import style0 from "./taskForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports